
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {
      valorDoCupom: '',
      errorCupom: '',
      cupom: '',
      loading: false,
      cupomChip: false,
    }
  },
  computed: {
    ...mapGetters('cart', ['totalCartPrice', 'discountPrice']),
    ...mapGetters('unidade', ['unidadeInformation']),
    ...mapState('cupom', ['name_cupom_Discount']),
  },
  methods: {
    ...mapActions('cart', ['setPercentDiscount', 'setFixedDiscount']),
    ...mapActions('cupom', ['getCupomDiscount']),
    ...mapMutations('cupom', ['CLEAN_CUPOM']),
    async cupomValidation() {
      this.loading = true
      try {
        const { data } = await this.getCupomDiscount(this.valorDoCupom)
        if (data.cpfCnpj !== this.unidadeInformation.cpfcnpj) {
          return this.$toast.error('cupom inválido.')
        }
        if (data.status === false) {
          return this.$toast.error('cupom desativado.')
        }
        if (data.tipoDesconto === 'VALOR_FIXO') {
          this.setFixedDiscount(data.valor)
        } else {
          this.setPercentDiscount(data.valor)
        }
        this.cupom = data
        this.errorCupom = ''
        this.$toast.success('Desconto aplicado.')
      } catch (error) {
        console.error(error)
        const { data } = error.response
        this.errorCupom = data.message
      } finally {
        this.loading = false
      }
    },
    transNomeToUpperCase() {
      this.valorDoCupom = this.valorDoCupom.toUpperCase()
    },
    cupomClose() {
      this.setPercentDiscount(0)
      this.setFixedDiscount(0)
      this.CLEAN_CUPOM()
      this.cupom = ''
      this.valorDoCupom = ''
    },
  },
}
